// extracted by mini-css-extract-plugin
export default {"balancedarchexample":"c949ab42760ad7e319bc","description":"f25c940444e8894e84d9"};